import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterCondicoesAsync
}

export const obterCondicoesAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/CondicaoPagamento/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}
export const enviarCondicaoPagamentoAsync = async (descricao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/CondicaoPagamento`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarCondicaoPagamentoAsync = async (id, descricao, ativo) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/CondicaoPagamento`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}